import { IconProps } from './index';

export const HistoryIcon = ({ color, className }: IconProps) => {
  return (
    <svg
      width='18'
      height='16'
      viewBox='0 0 18 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M3.25 8C3.25 6.66498 3.64588 5.35993 4.38758 4.2499C5.12928 3.13987 6.18349 2.2747 7.41689 1.76381C8.65029 1.25292 10.0075 1.11925 11.3169 1.3797C12.6262 1.64015 13.829 2.28303 14.773 3.22703C15.717 4.17104 16.3599 5.37377 16.6203 6.68315C16.8808 7.99252 16.7471 9.34972 16.2362 10.5831C15.7253 11.8165 14.8601 12.8707 13.7501 13.6124C12.6401 14.3541 11.335 14.75 9.99999 14.75'
        stroke='url(#paint0_linear_8623_160087)'
        strokeWidth='1.5'
      />
      <path
        opacity='0.75'
        d='M9.25 5.75V8.75H11.5'
        stroke={color}
        strokeOpacity={1}
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path d='M3.25 11L5.84808 6.5H0.651924L3.25 11Z' fill={color} fillOpacity={1} />
      <defs>
        <linearGradient id='paint0_linear_8623_160087' x1='10' y1='8' x2='10' y2='16' gradientUnits='userSpaceOnUse'>
          <stop style={{ stopColor: color, stopOpacity: 1 }} />
          <stop offset='1' stopColor='white' style={{ stopColor: 'white', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
    </svg>
  );
};
